// extracted by mini-css-extract-plugin
module.exports = {"job-board-wrapper":"JobsWrapper_job-board-wrapper__zufzG","loading":"JobsWrapper_loading__e30PR","jobposts-empty-wrapper":"JobsWrapper_jobposts-empty-wrapper__Odtvv"};